import {
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES,
  type OrderStatus,
} from '../../types/order';

// UI-only progress rail for customer orders. Backend remains the source of
// truth for allowed transitions; this array only defines detail-page order.
export const CUSTOMER_ORDER_PROGRESS_STATUSES: OrderStatus[] =
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES.filter(
    (status) => status !== 'ON_HOLD' && status !== 'CANCELLED',
  );

export const getCustomerOrderProgressStatuses = (
  _currentStatus: OrderStatus,
  _statusHistory: Array<{ status?: string | null }> = [],
): OrderStatus[] => CUSTOMER_ORDER_PROGRESS_STATUSES;
